var React = require('react');

function Header (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 442.495L64 410.888C128 379.281 256 316.068 384 316.068C512 316.068 640 379.281 768 431.959C896 484.637 1024 526.78 1152 537.315C1280 547.851 1408 526.78 1536 484.637C1664 442.495 1792 379.281 1856 347.675L1920 316.068V0H1856C1792 0 1664 0 1536 0C1408 0 1280 0 1152 0C1024 0 896 0 768 0C640 0 512 0 384 0C256 0 128 0 64 0H0V442.495Z","fill":"#9C27B0"}));
}

Header.defaultProps = {"width":"1920","height":"540","viewBox":"0 0 1920 540","fill":"none"};

module.exports = Header;

Header.default = Header;
